import {
  refreshMetrics,
  revokeResult,
  signalPlanChange,
  state,
} from "./core.js"
import { refreshCropMetrics } from "./crop.js"
import { refreshWorkerControl } from "./workers.js"

const byId = (id) => document.getElementById(id)
let initialized = false

function controls() {
  return {
    toggle: byId("motionStabilizerToggle"),
    strength: byId("stabilizerStrengthSlider"),
    smoothing: byId("stabilizerSmoothingSlider"),
    maxCorrection: byId("stabilizerMaxCorrectionSlider"),
    maxRotation: byId("stabilizerMaxRotationSlider"),
  }
}

function refreshStabilizerUi() {
  const { toggle, strength, smoothing, maxCorrection, maxRotation } = controls()
  const enabled = Boolean(toggle?.checked)
  for (const id of [
    "stabilizerStrengthCard",
    "stabilizerSmoothingCard",
    "stabilizerMaxCorrectionCard",
    "stabilizerMaxRotationCard",
  ]) byId(id)?.classList.toggle("disabled-control", !enabled)
  for (const input of [strength, smoothing, maxCorrection, maxRotation]) if (input) input.disabled = !enabled
  if (byId("stabilizerStrengthValue")) byId("stabilizerStrengthValue").textContent = `${strength?.value || 200}%`
  if (byId("stabilizerSmoothingValue")) byId("stabilizerSmoothingValue").textContent = `${smoothing?.value || 24} frames`
  if (byId("stabilizerMaxCorrectionValue")) byId("stabilizerMaxCorrectionValue").textContent = `${maxCorrection?.value || 25}%`
  if (byId("stabilizerMaxRotationValue")) byId("stabilizerMaxRotationValue").textContent = `${maxRotation?.value || 15}°`
  const helper = byId("stabilizerHelper")
  if (helper) helper.textContent = enabled
    ? "Aggressive translation + rotation stabilization with automatic edge-safe zoom"
    : "Off"
}

function stabilizerChanged(reason) {
  refreshStabilizerUi()
  revokeResult(true)
  refreshMetrics()
  refreshCropMetrics()
  refreshWorkerControl()
  signalPlanChange(reason)
}

export function setupStabilizerUi() {
  if (initialized) return
  initialized = true
  const { toggle, strength, smoothing, maxCorrection, maxRotation } = controls()
  for (const input of [toggle, strength, smoothing, maxCorrection, maxRotation]) {
    input?.addEventListener("input", () => stabilizerChanged(input.id))
    input?.addEventListener("change", () => stabilizerChanged(input.id))
  }

  addEventListener("converter-stabilizer-progress", (event) => {
    const { done, total, stage } = event.detail || {}
    const overlay = byId("previewLoading")
    const text = byId("previewLoadingText")
    const count = byId("previewLoadingCount")
    if (!state.encoding && overlay) {
      overlay.hidden = false
      if (text) text.textContent = stage || "Stabilizing motion"
      if (count) count.textContent = `${done || 0}/${total || 0}`
    }
    if (state.encoding) {
      const phase = byId("progressPhase")
      if (phase) phase.textContent = `Phase 1/4 · ${stage || "Stabilizing motion"} ${done || 0}/${total || 0}`
    }
  })

  addEventListener("converter-stabilizer-complete", (event) => {
    const zoom = Number(event.detail?.zoom) || 1
    const rotation = Number(event.detail?.maximumRotation) || 0
    const helper = byId("stabilizerHelper")
    if (helper && toggle?.checked) helper.textContent = `Applied · edge zoom ${zoom.toFixed(3)}× · max rotation ${rotation.toFixed(2)}°`
  })

  refreshStabilizerUi()
}
